import { removeConversation, leaveMessageFormSubmit } from '../../actions';
import LeaveMessage from './LeaveMessage';
import { connect } from 'react-redux';
import { LocationState, RootState, TeamsState } from '../../typedefs/store';
import { getLocation, getTeams, getUi } from '../../selectors/conversation';

const mapStateToProps = (state: RootState) => {
    const location: LocationState = getLocation(state);
    const teams = getTeams(state);
    const ui = getUi(state);
    return {
        phone: location.phone,
        teams,
        formStatus: ui.leaveMessageForm,
    };
};

const mapDispatchToProps = { removeConversation, submit: leaveMessageFormSubmit };

export default connect(mapStateToProps, mapDispatchToProps)(LeaveMessage);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/LeaveMessage/LeaveMessageContainer.tsx